import { render, staticRenderFns } from "./UploadFormButtons.vue?vue&type=template&id=7097bad3&scoped=true&"
import script from "./UploadFormButtons.vue?vue&type=script&lang=js&"
export * from "./UploadFormButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7097bad3",
  null
  
)

export default component.exports